import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    class: "quiz-intro-drawer",
    key: "page1"
};
const _hoisted_2 = { class: "quiz-intro-header" };
const _hoisted_3 = { class: "quiz-intro-content" };
const _hoisted_4 = { class: "quiz-intro-title" };
const _hoisted_5 = { class: "quiz-intro-subtitle" };
const _hoisted_6 = { class: "quiz-intro-image" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "quiz-intro-footer" };
const _hoisted_9 = { class: "quiz-intro-text" };
const _hoisted_10 = { class: "quiz-day" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "quiz-intro-actions" };
const _hoisted_13 = {
    class: "quiz-question-drawer",
    key: "page2"
};
const _hoisted_14 = { class: "quiz-question-header" };
const _hoisted_15 = { class: "quiz-day-indicator" };
const _hoisted_16 = { class: "day-badge" };
const _hoisted_17 = { class: "day-number" };
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "quiz-question-content" };
const _hoisted_20 = { class: "question-text" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { class: "answer-letter" };
const _hoisted_23 = ["src"];
const _hoisted_24 = {
    class: "quiz-result-loading",
    key: "page3-loading"
};
const _hoisted_25 = {
    class: "quiz-result-drawer",
    key: "page3"
};
const _hoisted_26 = { class: "quiz-result-header" };
const _hoisted_27 = { class: "result-status" };
const _hoisted_28 = ["src"];
const _hoisted_29 = ["src"];
const _hoisted_30 = { class: "result-title" };
const _hoisted_31 = {
    key: 0,
    class: "result-stat"
};
const _hoisted_32 = { class: "quiz-result-content" };
const _hoisted_33 = { class: "correct-answer-card" };
const _hoisted_34 = { class: "answer-indicator" };
const _hoisted_35 = { class: "answer-letter-result" };
const _hoisted_36 = { class: "answer-text-result" };
const _hoisted_37 = { class: "explanation-text" };
const _hoisted_38 = {
    key: 0,
    class: "example-text"
};
const _hoisted_39 = { class: "chat-button-wrapper" };
const _hoisted_40 = {
    class: "quiz-stats-drawer",
    key: "page4"
};
const _hoisted_41 = {
    key: 0,
    class: "stats-day-number",
    style: { textShadow: '0 0 8px rgba(0,0,0,0.3), 0 0 4px rgba(0,0,0,0.2)' }
};
const _hoisted_42 = ["src"];
const _hoisted_43 = { class: "stats-cards" };
const _hoisted_44 = { class: "stat-card-group" };
const _hoisted_45 = { class: "stat-number" };
const _hoisted_46 = {
    key: 0,
    class: "bonus-animation"
};
const _hoisted_47 = {
    key: 1,
    class: "stat-value"
};
const _hoisted_48 = { class: "stat-number" };
const _hoisted_49 = {
    key: 0,
    class: "bonus-animation"
};
const _hoisted_50 = {
    key: 1,
    class: "stat-value"
};
const _hoisted_51 = { class: "stat-header-streak" };
const _hoisted_52 = { class: "streak-count" };
const _hoisted_53 = { class: "streak-current" };
const _hoisted_54 = { class: "streak-total" };
const _hoisted_55 = {
    key: 0,
    class: "milestone-marker"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = {
    key: 1,
    class: "milestone-dot-wrapper"
};
const _hoisted_58 = { class: "stat-number" };
const _hoisted_59 = {
    key: 0,
    class: "bonus-animation"
};
const _hoisted_60 = {
    key: 1,
    class: "stat-value"
};
const _hoisted_61 = {
    key: 0,
    class: "stats-footer"
};
const _hoisted_62 = { class: "stats-message" };
const _hoisted_63 = { class: "quiz-notifications" };
const _hoisted_64 = { class: "quiz-notifications-toggle" };
const _hoisted_65 = { class: "toggle-control" };
import { ref, computed, nextTick } from 'vue';
import DrawerPanel from './DrawerPanel.vue';
import MGButton from './MGButton.vue';
import ChatMgButton from './ChatMgButton.vue';
import QuizFinalDayFallingEffect from './QuizFinalDayFallingEffect.vue';
import quizDefaultBg from '@/assets/quiz/quiz-default-bg.png';
import peelLargeSvg from '@/assets/quiz/peel-large.svg';
import arrowRightImg from '@/assets/arrow-right.png';
import tickImg from '@/assets/quiz/tick.png';
import crossImg from '@/assets/quiz/cross.png';
import flameImg from '@/assets/quiz/flame.png';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuizDrawerPlayPanel',
    props: {
        openHeight: { default: '80%' },
        quiz: {},
        customer: {},
        originalQuizPoints: {},
        answerResponse: {},
        openToStats: { type: Boolean, default: false }
    },
    emits: ["terms-click", "continue", "back-to-home", "submit-answer", "drawer-opened", "drawer-closed", "notifications-change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Template ref
        const quizdrawer = ref(null);
        // Data
        const currentPage = ref(1);
        const selectedAnswer = ref(null);
        const isCorrect = ref(false);
        // Animation state
        const displayTotalAnswered = ref(0);
        const displayTotalCorrect = ref(0);
        const displayStreakBefore = ref(0);
        const displayStreakAfter = ref(0);
        const displayPrizeEntries = ref(0);
        const prizeBonus = ref(0);
        const peelAnimate = ref(false);
        const card1Animate = ref(false);
        const card2Animate = ref(false);
        const card3Animate = ref(false);
        const showTotalAnsweredBonus = ref(false);
        const showStreakBonus = ref(false);
        const showPrizeBonus = ref(false);
        const hitMilestoneDay = ref(null);
        const isMilestoneHit = ref(false);
        const flameDisappearing = ref(false);
        const animationsComplete = ref(false);
        // Computed
        const dynamicHeight = computed(() => {
            return currentPage.value === 1 ? 'calc(90vh + 95px)' : 'calc(100vh + 95px)';
        });
        const heading = computed(() => props.quiz.tagLineHeader);
        const headingDescription = computed(() => {
            const q = props.quiz.questions.find((q) => isQuestionCurrent(q));
            return q ? q.dailyDescription : '';
        });
        const preamble = computed(() => {
            const q = props.quiz.questions.find((q) => isQuestionCurrent(q));
            return q ? q.preamble : '';
        });
        const currentQuestion = computed(() => {
            return props.quiz.questions.find((q) => isQuestionCurrent(q));
        });
        const currentDay = computed(() => {
            return currentQuestion.value ? props.quiz.questions.indexOf(currentQuestion.value) + 1 : 0;
        });
        const totalDays = computed(() => props.quiz.questions.length);
        const isFinalQuestion = computed(() => {
            // When on stats page (openToStats), use originalTotalAnswered instead of currentDay
            // because currentDay relies on finding an active question which may not exist
            const dayToCheck = props.openToStats ? originalTotalAnswered.value : currentDay.value;
            return dayToCheck === totalDays.value;
        });
        // Safe asset URLs
        const currentQuestionBg = computed(() => {
            if (currentQuestion.value && currentQuestion.value.bgUrl)
                return currentQuestion.value.bgUrl;
            return quizDefaultBg || '';
        });
        const defaultQuizBg = computed(() => quizDefaultBg || '');
        const peelLarge = computed(() => peelLargeSvg || '');
        const arrowRight = computed(() => arrowRightImg || '');
        const tickUrl = computed(() => tickImg || '');
        const crossUrl = computed(() => crossImg || '');
        const flameUrl = computed(() => flameImg || '');
        const statsBackgroundStyle = computed(() => {
            const defaultBg = defaultQuizBg.value || '';
            const bg = props.openToStats ? (props.quiz?.bgUrl || defaultBg) : (currentQuestion.value?.thumbUrl || defaultBg);
            return { backgroundImage: bg ? `url(${bg})` : '' };
        });
        const questionText = computed(() => currentQuestion.value ? currentQuestion.value.value : '');
        const possibleAnswers = computed(() => currentQuestion.value ? currentQuestion.value.answers : []);
        const hasLongAnswers = computed(() => {
            return possibleAnswers.value.some((answer) => answer.value && answer.value.length > 40);
        });
        const percentageWrong = computed(() => {
            if (props.answerResponse.percentageCorrectCustomers == 0) {
                return null;
            }
            return props.answerResponse ? Math.round(100 - props.answerResponse.percentageCorrectCustomers) : null;
        });
        const selectedAnswerLetter = computed(() => {
            if (selectedAnswer.value) {
                const index = possibleAnswers.value.indexOf(selectedAnswer.value);
                return String.fromCharCode(65 + index);
            }
            return '';
        });
        const correctAnswer = computed(() => {
            if (!currentQuestion.value || !currentQuestion.value.answers) {
                return null;
            }
            return currentQuestion.value.answers.find((answer) => answer.isCorrect);
        });
        const correctAnswerLetter = computed(() => {
            if (correctAnswer.value) {
                const index = possibleAnswers.value.indexOf(correctAnswer.value);
                return String.fromCharCode(65 + index);
            }
            return '';
        });
        const explanation = computed(() => currentQuestion.value ? currentQuestion.value.answerDescription : '');
        const example = computed(() => currentQuestion.value ? currentQuestion.value.example : '');
        const milestoneInterval = computed(() => props.originalQuizPoints?.streakMeterInterval || 5);
        const totalAnswered = computed(() => props.answerResponse?.points.answered || 0);
        const totalCorrect = computed(() => props.answerResponse?.points.correct || 0);
        const originalTotalAnswered = computed(() => props.originalQuizPoints?.answered || 0);
        const originalTotalCorrect = computed(() => props.originalQuizPoints?.correct || 0);
        const currentStreak = computed(() => props.originalQuizPoints?.streakMeter || 0);
        const prizeEntries = computed(() => props.answerResponse?.points.total || 0);
        const milestoneDays = computed(() => {
            // Determine which streak value to show based on animation state
            const streakToShow = card2Animate.value ? displayStreakAfter.value : displayStreakBefore.value;
            const result = Array.from({ length: totalDays.value + 1 }, (_, i) => {
                const day = i + 1;
                const isMilestone = day === 1 || (day - 1) % milestoneInterval.value === 0;
                const isFilled = (day === 1 && streakToShow > 0) || (day > 1 && streakToShow >= day - 1);
                let label = null;
                if (isMilestone && day > 1) {
                    const milestoneNumber = (day - 1) / milestoneInterval.value;
                    const bonus = milestoneNumber === Math.floor(totalDays.value / milestoneInterval.value) ? totalDays.value : (day - 1);
                    label = `+${bonus}`;
                }
                return {
                    day,
                    isMilestone,
                    isFilled,
                    isFirst: day === 1,
                    label,
                    labelIsActive: streakToShow >= day - 1,
                };
            });
            return result;
        });
        const notificationsEnabled = computed({
            get() {
                return props.customer?.preferences?.quizNotifications ?? true;
            },
            set(value) {
                emit('notifications-change', value);
            }
        });
        // Methods
        function isQuestionCurrent(question) {
            if (!question || !question.startDateTime || !question.endDateTime) {
                return false;
            }
            const now = new Date();
            const startDate = new Date(question.startDateTime);
            const endDate = new Date(question.endDateTime);
            return now >= startDate && now <= endDate;
        }
        function openDrawer() {
            // Check if there's a current question available (unless opening to stats only)
            if (!props.openToStats && !currentQuestion.value) {
                return;
            }
            quizdrawer.value?.openDrawer();
            // Open directly to stats page if requested
            if (props.openToStats) {
                currentPage.value = 4;
                isCorrect.value = false;
                // Set display values to current values (no animation)
                displayTotalAnswered.value = props.originalQuizPoints?.answered || 0;
                displayTotalCorrect.value = props.originalQuizPoints?.correct || 0;
                displayStreakBefore.value = props.originalQuizPoints?.streakMeter || 0;
                displayStreakAfter.value = props.originalQuizPoints?.streakMeter || 0;
                displayPrizeEntries.value = props.originalQuizPoints?.total || 0;
                prizeBonus.value = 0;
                card1Animate.value = true;
                card2Animate.value = true;
                card3Animate.value = true;
                animationsComplete.value = true;
            }
            else {
                currentPage.value = 1;
                selectedAnswer.value = null;
                // Reset animation state
                displayTotalAnswered.value = 0;
                displayTotalCorrect.value = 0;
                displayPrizeEntries.value = 0;
                prizeBonus.value = 0;
                peelAnimate.value = false;
                card1Animate.value = false;
                card2Animate.value = false;
                card3Animate.value = false;
                showTotalAnsweredBonus.value = false;
                showStreakBonus.value = false;
                showPrizeBonus.value = false;
                hitMilestoneDay.value = null;
                isMilestoneHit.value = false;
                flameDisappearing.value = false;
                animationsComplete.value = false;
            }
        }
        function closeDrawer() {
            quizdrawer.value?.closeDrawer();
        }
        function goToQuestion() {
            currentPage.value = 2;
        }
        function goBack() {
            currentPage.value = 1;
            selectedAnswer.value = null;
        }
        function selectAnswer(answer) {
            selectedAnswer.value = answer;
        }
        function submitAnswer(answer) {
            if (answer !== null) {
                // Check if the current question has expired
                if (!isQuestionCurrent(currentQuestion.value)) {
                    // Question has expired, close drawer and go back to home
                    closeDrawer();
                    emit('back-to-home', false);
                    return;
                }
                emit('submit-answer', answer);
                currentPage.value = 3;
            }
        }
        function onGoToStats() {
            // Set isCorrect from answerResponse
            isCorrect.value = props.answerResponse?.isCorrect || false;
            // Initialize animation state
            resetAnimationState();
            currentPage.value = 4;
            runAnimations();
        }
        function onBackToHomeClick() {
            emit('back-to-home', isCorrect.value);
            closeDrawer();
        }
        function toggleNotifications() {
            notificationsEnabled.value = !notificationsEnabled.value;
        }
        function replayAnimations() {
            // Reset animation state
            resetAnimationState();
            // Pause 1 second before starting animations
            nextTick(async () => {
                await delay(1000);
                runAnimations();
            });
        }
        // Shared method to initialize/reset animation state
        function resetAnimationState() {
            // Initialize display values (before animation) - use original values directly
            displayTotalAnswered.value = originalTotalAnswered.value;
            displayTotalCorrect.value = originalTotalCorrect.value;
            displayStreakBefore.value = (props.originalQuizPoints?.streakMeter || 0);
            displayStreakAfter.value = props.answerResponse?.points.streakMeter || 0;
            // Calculate the actual difference between before and after totals
            const origTotal = props.originalQuizPoints?.total || 0;
            const newTotal = props.answerResponse?.points.total || 0;
            prizeBonus.value = newTotal - origTotal;
            // Start with original total (before answering)
            displayPrizeEntries.value = origTotal;
            // Reset animation flags
            peelAnimate.value = false;
            card1Animate.value = false;
            card2Animate.value = false;
            card3Animate.value = false;
            showTotalAnsweredBonus.value = false;
            showStreakBonus.value = false;
            showPrizeBonus.value = false;
            hitMilestoneDay.value = null;
            flameDisappearing.value = false;
            animationsComplete.value = false;
            // Check if a milestone was hit - show flame whenever streak reaches a milestone
            const newStreak = props.answerResponse?.points.streakMeter || 0;
            const interval = parseInt(milestoneInterval.value, 10);
            isMilestoneHit.value = (newStreak > 0 && newStreak % interval === 0);
            console.log('Milestone check:', {
                newStreak,
                interval,
                isCorrect: isCorrect.value,
                isMilestoneHit: isMilestoneHit.value,
                calculation: newStreak % interval,
                willShowOnDay: newStreak + 1
            });
        }
        // Helper function for delays
        function delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
        async function runAnimations() {
            // Initial delay before starting peel animation
            await delay(1000);
            peelAnimate.value = true;
            // Wait for peel animation to complete
            await delay(1000);
            // Panel 1: Total Answered animation
            card1Animate.value = true;
            showTotalAnsweredBonus.value = true;
            await delay(1000);
            showTotalAnsweredBonus.value = false;
            displayTotalAnswered.value = totalAnswered.value;
            displayTotalCorrect.value = totalCorrect.value;
            // Panel 2: Streak animation
            await delay(100);
            card2Animate.value = true;
            if (isCorrect.value) {
                showStreakBonus.value = true;
                await delay(500);
                showStreakBonus.value = false;
            }
            // Milestone flame animation if applicable (runs in background)
            // Show flame regardless of whether answer was correct or not
            if (isMilestoneHit.value) {
                // The flame should appear on the milestone day marker
                // If streak = 5, the milestone day is 6 (because day = streak + 1)
                const milestoneDayNumber = props.answerResponse?.points.streakMeter + 1 || 0;
                hitMilestoneDay.value = milestoneDayNumber;
                console.log('Showing flame on day:', milestoneDayNumber);
                console.log('Milestone days array:', milestoneDays.value.filter(m => m.isMilestone).map(m => ({ day: m.day, label: m.label })));
                // Start flame disappear after 2000ms, don't wait for it
                setTimeout(async () => {
                    flameDisappearing.value = true;
                    await delay(500);
                    hitMilestoneDay.value = null;
                    isMilestoneHit.value = false;
                    flameDisappearing.value = false;
                }, 2000);
            }
            else {
                console.log('No milestone hit - isMilestoneHit is false');
            }
            // Panel 3: Prize Entries animation (starts while flame may still be visible)
            await delay(800);
            card3Animate.value = true;
            showPrizeBonus.value = true;
            await delay(1000);
            showPrizeBonus.value = false;
            displayPrizeEntries.value = prizeEntries.value;
            // All animations complete
            animationsComplete.value = true;
        }
        __expose({ openDrawer, closeDrawer });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DrawerPanel, {
                ref_key: "quizdrawer",
                ref: quizdrawer,
                title: "",
                bottom: "-95px",
                blurBackground: true,
                closeBackground: false,
                openHeight: dynamicHeight.value,
                closedHeight: "0px",
                startOpened: false,
                safeAreaPadding: currentPage.value !== 1,
                back: currentPage.value !== 3 && currentPage.value !== 1 && currentPage.value !== 4,
                close: currentPage.value !== 3 && currentPage.value !== 4,
                divider: false,
                backgroundColor: "#FFFFFF",
                openBackgroundColor: "#F9F7F3;",
                transitionDuration: ".5s",
                onGoBack: goBack,
                onOpened: _cache[7] || (_cache[7] = ($event) => (emit('drawer-opened'))),
                onClosed: _cache[8] || (_cache[8] = ($event) => (emit('drawer-closed')))
            }, {
                default: _withCtx(() => [
                    _createVNode(_Transition, {
                        name: "page-fade",
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (currentPage.value === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("h2", _hoisted_4, _toDisplayString(heading.value), 1),
                                            _createElementVNode("p", _hoisted_5, _toDisplayString(headingDescription.value), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("img", { src: currentQuestionBg.value }, null, 8, _hoisted_7)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, "Day " + _toDisplayString(currentDay.value) + " of " + _toDisplayString(totalDays.value), 1),
                                            _createElementVNode("p", {
                                                class: "preamble",
                                                innerHTML: preamble.value
                                            }, null, 8, _hoisted_11)
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createVNode(MGButton, {
                                                text: "Play now",
                                                fullWidth: false,
                                                arrow: true,
                                                noCaps: true,
                                                onClick: goToQuestion
                                            }),
                                            _createElementVNode("a", {
                                                href: "#",
                                                class: "quiz-terms-link",
                                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('terms-click')), ["prevent"]))
                                            }, "Terms & Conditions")
                                        ])
                                    ])
                                ]))
                                : (currentPage.value === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createElementVNode("span", _hoisted_17, _toDisplayString(currentDay.value), 1),
                                                    _createElementVNode("img", {
                                                        src: peelLarge.value,
                                                        class: "peel-corner"
                                                    }, null, 8, _hoisted_18)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("h2", _hoisted_20, _toDisplayString(questionText.value), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["quiz-question-footer", { 'has-selection': selectedAnswer.value !== null }])
                                        }, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["answer-options", { 'small-text': hasLongAnswers.value }])
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(possibleAnswers.value, (answer, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: index,
                                                        class: _normalizeClass(["answer-option", { 'selected': selectedAnswer.value === answer }]),
                                                        onClick: ($event) => (selectAnswer(answer))
                                                    }, [
                                                        _createElementVNode("span", _hoisted_22, _toDisplayString(String.fromCharCode(65 + index)), 1),
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["answer-text", { 'answer-text-selected': selectedAnswer.value === answer }])
                                                        }, _toDisplayString(answer.value), 3),
                                                        (selectedAnswer.value === answer)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: arrowRight.value,
                                                                class: "answer-arrow",
                                                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (submitAnswer(selectedAnswer.value)), ["stop"]))
                                                            }, null, 8, _hoisted_23))
                                                            : _createCommentVNode("", true)
                                                    ], 10, _hoisted_21));
                                                }), 128))
                                            ], 2),
                                            (selectedAnswer.value !== null)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 0,
                                                    text: "Submit",
                                                    fullWidth: false,
                                                    arrow: true,
                                                    disabled: selectedAnswer.value === null,
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (submitAnswer(selectedAnswer.value)))
                                                }, null, 8, ["disabled"]))
                                                : _createCommentVNode("", true)
                                        ], 2)
                                    ]))
                                    : (currentPage.value === 3 && !_ctx.answerResponse)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[9] || (_cache[9] = [
                                            _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                                            _createElementVNode("p", { class: "loading-text" }, "Checking your answer...", -1)
                                        ])))
                                        : (currentPage.value === 3 && _ctx.answerResponse)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                _createElementVNode("div", _hoisted_26, [
                                                    _createElementVNode("div", _hoisted_27, [
                                                        (_ctx.answerResponse.isCorrect)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: tickUrl.value,
                                                                width: "45",
                                                                height: "40"
                                                            }, null, 8, _hoisted_28))
                                                            : (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: crossUrl.value,
                                                                width: "40",
                                                                height: "40"
                                                            }, null, 8, _hoisted_29)),
                                                        _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.answerResponse.isCorrect ? 'Correct!' : 'Oops, not quite!'), 1)
                                                    ]),
                                                    (percentageWrong.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                            _createElementVNode("span", null, _toDisplayString(percentageWrong.value) + "% of players got that wrong!", 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _createElementVNode("div", _hoisted_34, [
                                                            _createElementVNode("span", _hoisted_35, _toDisplayString(correctAnswerLetter.value), 1)
                                                        ]),
                                                        _createElementVNode("span", _hoisted_36, _toDisplayString(correctAnswer.value ? correctAnswer.value.value : ''), 1)
                                                    ]),
                                                    _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.answerResponse.answerDescription), 1),
                                                    (_ctx.answerResponse.answerExample)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                            _createElementVNode("p", null, _toDisplayString(_ctx.answerResponse.answerExample), 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", {
                                                    class: "quiz-result-footer",
                                                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
                                                }, [
                                                    _createElementVNode("div", _hoisted_39, [
                                                        _createVNode(ChatMgButton, {
                                                            hover: false,
                                                            prompt: questionText.value,
                                                            initialPrompt: true,
                                                            size: 64
                                                        }, null, 8, ["prompt"])
                                                    ]),
                                                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "centered" }, "More questions? Ask our Financial Assistant", -1)),
                                                    _createVNode(MGButton, {
                                                        text: "Continue",
                                                        onClick: onGoToStats,
                                                        fullWidth: false,
                                                        arrow: true
                                                    }),
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        class: "quiz-terms-link",
                                                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (emit('terms-click')), ["prevent"]))
                                                    }, "Terms & Conditions")
                                                ])
                                            ]))
                                            : (currentPage.value === 4)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                    (isFinalQuestion.value && _ctx.quiz.finalDaySpecialImageUrl)
                                                        ? (_openBlock(), _createBlock(QuizFinalDayFallingEffect, {
                                                            key: 0,
                                                            imageSrc: _ctx.quiz.finalDaySpecialImageUrl
                                                        }, null, 8, ["imageSrc"]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["stats-day-badge", { 'peel-active': peelAnimate.value, 'clickable': animationsComplete.value && !_ctx.openToStats }]),
                                                        style: _normalizeStyle(statsBackgroundStyle.value),
                                                        onClick: _cache[5] || (_cache[5] = ($event) => (!_ctx.openToStats && animationsComplete.value && replayAnimations()))
                                                    }, [
                                                        (!_ctx.openToStats)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(currentDay.value || '?'), 1))
                                                            : _createCommentVNode("", true),
                                                        (!_ctx.openToStats)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: peelLarge.value,
                                                                class: "peel-corner-stats"
                                                            }, null, 8, _hoisted_42))
                                                            : _createCommentVNode("", true)
                                                    ], 6),
                                                    _createElementVNode("div", _hoisted_43, [
                                                        _createElementVNode("div", _hoisted_44, [
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass(["stat-card", { 'has-value': card1Animate.value }])
                                                            }, [
                                                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-header" }, [
                                                                    _createElementVNode("span", { class: "stat-title" }, [
                                                                        _createTextVNode("Total"),
                                                                        _createElementVNode("br"),
                                                                        _createTextVNode("Answered")
                                                                    ])
                                                                ], -1)),
                                                                _createElementVNode("div", _hoisted_45, [
                                                                    (showTotalAnsweredBonus.value)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, "+1"))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(displayTotalAnswered.value), 1))
                                                                ])
                                                            ], 2),
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass(["stat-card", { 'has-value': card1Animate.value }])
                                                            }, [
                                                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-header" }, [
                                                                    _createElementVNode("span", { class: "stat-title" }, [
                                                                        _createTextVNode("Total"),
                                                                        _createElementVNode("br"),
                                                                        _createTextVNode("Correct")
                                                                    ])
                                                                ], -1)),
                                                                _createElementVNode("div", _hoisted_48, [
                                                                    (showTotalAnsweredBonus.value && isCorrect.value)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "+1"))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(displayTotalCorrect.value), 1))
                                                                ])
                                                            ], 2)
                                                        ]),
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["stat-card stat-card-streak", { 'has-value': card2Animate.value }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_51, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "stat-title" }, "Play streak count", -1)),
                                                                _createElementVNode("div", _hoisted_52, [
                                                                    _createElementVNode("span", _hoisted_53, _toDisplayString(card2Animate.value ? displayStreakAfter.value : displayStreakBefore.value), 1),
                                                                    _createElementVNode("span", _hoisted_54, "/" + _toDisplayString(totalDays.value), 1)
                                                                ])
                                                            ]),
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass(["streak-milestones", { 'streak-milestones-empty': (card2Animate.value ? displayStreakAfter.value : displayStreakBefore.value) === 0 }])
                                                            }, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(milestoneDays.value, (milestone, index) => {
                                                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                                                        key: milestone.day
                                                                    }, [
                                                                        (milestone.isMilestone && !milestone.isFirst)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                                (hitMilestoneDay.value === milestone.day)
                                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                                        key: 0,
                                                                                        src: flameUrl.value,
                                                                                        class: _normalizeClass(["milestone-flame", { 'flame-disappear': flameDisappearing.value }])
                                                                                    }, null, 10, _hoisted_56))
                                                                                    : _createCommentVNode("", true),
                                                                                _createElementVNode("div", {
                                                                                    class: _normalizeClass([milestone.isFilled ? 'milestone-circle' : 'milestone-empty-large', "dot-fill-animate"]),
                                                                                    style: _normalizeStyle(milestone.isFilled && card2Animate.value ? { animationDelay: (index * 0.08) + 's' } : {})
                                                                                }, null, 6),
                                                                                (milestone.label)
                                                                                    ? (_openBlock(), _createElementBlock("span", {
                                                                                        key: 1,
                                                                                        class: _normalizeClass(["milestone-label", { 'milestone-label-active': milestone.labelIsActive }])
                                                                                    }, _toDisplayString(milestone.label), 3))
                                                                                    : _createCommentVNode("", true)
                                                                            ]))
                                                                            : (!milestone.isMilestone)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                                    _createElementVNode("div", {
                                                                                        class: _normalizeClass([(card2Animate.value ? displayStreakAfter.value : displayStreakBefore.value) >= milestone.day - 1 ? 'milestone-dot-small' : 'milestone-dot-small-empty', "dot-fill-animate"]),
                                                                                        style: _normalizeStyle((card2Animate.value ? displayStreakAfter.value : displayStreakBefore.value) >= milestone.day - 1 && card2Animate.value ? { animationDelay: (index * 0.08) + 's' } : {})
                                                                                    }, null, 6)
                                                                                ]))
                                                                                : _createCommentVNode("", true)
                                                                    ], 64));
                                                                }), 128))
                                                            ], 2)
                                                        ], 2),
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["stat-card", { 'has-value': card3Animate.value }])
                                                        }, [
                                                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat-header" }, [
                                                                _createElementVNode("span", { class: "stat-title" }, [
                                                                    _createTextVNode("Prize draw"),
                                                                    _createElementVNode("br"),
                                                                    _createTextVNode("entries")
                                                                ])
                                                            ], -1)),
                                                            _createElementVNode("div", _hoisted_58, [
                                                                (showPrizeBonus.value)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, "+" + _toDisplayString(prizeBonus.value), 1))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(displayPrizeEntries.value), 1))
                                                            ])
                                                        ], 2)
                                                    ]),
                                                    _createVNode(_Transition, null, {
                                                        default: _withCtx(() => [
                                                            (animationsComplete.value)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                                    _createElementVNode("p", _hoisted_62, [
                                                                        (isFinalQuestion.value)
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                (totalCorrect.value === totalDays.value)
                                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                        _cache[15] || (_cache[15] = _createTextVNode(" Congratulations!")),
                                                                                        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                                                                        _cache[17] || (_cache[17] = _createTextVNode(" You have earned maximum entries to our prize draw. We will be contacting winners soon, good luck! "))
                                                                                    ], 64))
                                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                        _createTextVNode(" That's it! We will be contacting winners soon, good luck! ")
                                                                                    ], 64))
                                                                            ], 64))
                                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                _createTextVNode(" Remember, there are bonus entries everytime you +" + _toDisplayString(milestoneInterval.value) + " to your streak. Check back tomorrow to maximise your entries! ", 1)
                                                                            ], 64))
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_63, [
                                                                        _createElementVNode("div", _hoisted_64, [
                                                                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "toggle-label" }, "Notifications:", -1)),
                                                                            _createElementVNode("div", _hoisted_65, [
                                                                                _createElementVNode("span", {
                                                                                    class: _normalizeClass(["toggle-text", { 'active': !notificationsEnabled.value }])
                                                                                }, "Off", 2),
                                                                                _createElementVNode("div", {
                                                                                    class: _normalizeClass(["toggle-switch", { 'toggle-on': notificationsEnabled.value }]),
                                                                                    onClick: toggleNotifications
                                                                                }, _cache[18] || (_cache[18] = [
                                                                                    _createElementVNode("div", { class: "toggle-knob" }, null, -1)
                                                                                ]), 2),
                                                                                _createElementVNode("span", {
                                                                                    class: _normalizeClass(["toggle-text", { 'active': notificationsEnabled.value }])
                                                                                }, "On", 2)
                                                                            ])
                                                                        ])
                                                                    ]),
                                                                    _createVNode(MGButton, {
                                                                        text: "Back to home",
                                                                        arrow: true,
                                                                        fullWidth: false,
                                                                        noCaps: true,
                                                                        onClick: onBackToHomeClick
                                                                    }),
                                                                    _createElementVNode("a", {
                                                                        href: "#",
                                                                        class: "quiz-terms-link",
                                                                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (emit('terms-click')), ["prevent"]))
                                                                    }, "Terms & Conditions")
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["openHeight", "safeAreaPadding", "back", "close"]));
        };
    }
});
